module.exports = __webpack_public_path__ + "img/img_6_ua.4cd74753.png";